// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"header_searchInput__hPf9i"};